import React, { PureComponent } from 'react';
import { Loading } from 'bongga-react-simple-chatbot';
import Faq from '../Faq';
import FaqResponse from '../FaqResponse';
import API from '../../utils/api';
import { connect } from 'react-redux';
import { setParams } from '../../redux/modules/agent';

class Data extends PureComponent {
  state = {
    loading: false,
    result: [],
  }

  getAgentResponse = async () => {
    const { setParams, steps, triggerNextStep } = this.props;
    const { subject } = steps;

    const query = encodeURI(subject.value);
      const resp = await API.queryAgent(query);
      const data = resp.data;
      const params = this.getParams(data.params);
      const intent = data.intent && data.intent.displayName;
      let trigger;

      switch(intent) {
        case 'welcome':
          trigger = 'agent-response-hello';
          break;

        case 'farewell':
          trigger = 'farewell';
          break;

        case 'question':
          trigger = params.product ? 'modules-step-one' : 'products-step-one';
        break;

        default:
          trigger = 'agent-response';
          break;
      }

      setParams(params);
      triggerNextStep({ value: data.response, trigger });
  }

  getFAQs = () => {
    const { steps, triggerNextStep, params, products } = this.props;
    let platform = -1;

    if(steps['products-step-two']) {
      platform = steps['products-step-two'].message;
    } else {
      const found = products.find(item => item.name.toLowerCase() === params.product);
      if(!!found) {
        platform = found.name;
      }
    }

    const item = steps['modules-step-three'].message;
    const option = steps['options-step-three'].message;

    this.setState({ loading: true });

    API.getData(platform, item, option).then(resp => {
      const data = resp.data.data;
      const trigger = data.length === 0 ? 'empty-data' : 'another-subject';

      this.setState({ loading: false, result: data }, () => {
        setTimeout(() => triggerNextStep({ value: undefined, trigger }), 500);
      });
    });
  }

  getParams = (data) => {
    let params = {};

    Object.keys(data).forEach(key => {
      const param = data[key].stringValue

      if(param.length > 0) {
        params[key] = data[key].stringValue
      }
    });

    return params;
  }

  componentDidUpdate() {

  }

  async componentDidMount() {
    const { canSearch } = this.props;

    if(canSearch) {
      this.getFAQs();
    } else {
      this.getAgentResponse();
    }
  }

  render() {
    const { canSearch } = this.props;
    const { loading, result } = this.state;

    if(canSearch) {
      return loading
      ? <Loading />
      : result.length === 0
        ? <FaqResponse>No hay resultados</FaqResponse>
        : <div style={{ maxWidth: '100%' }}>
          <FaqResponse>Resultados encontrados:</FaqResponse>
          {
            result.map((item, i) => (
              <div key={i}>
                {i + 1}. <Faq verticalSpace={10}>{item.question}</Faq>
                <FaqResponse
                  dangerouslySetInnerHTML={{ __html: item.response }}
                />
              </div>
            ))
          }
        </div>
    }

    return <Loading />
  }
}

const stateToProps = state => ({
  params: state.agent.params,
  products: state.products.data,
})

const actionsToProps = dispatch => ({
  setParams: data => dispatch(setParams(data)),
})

export default connect(stateToProps, actionsToProps)(Data);
